import { backgroundColors, color, contrastSafeLightness, primaryColors, type PersonalTheme } from "./personal-theme";

export function applyPersonalTheme(theme: PersonalTheme | null | undefined) {
  const root = document.documentElement;
  const primary = theme?.primaryColor;
  const background = theme?.backgroundColor;
  const names = ["--purple-950", "--purple-900", "--purple-800", "--purple-700", "--purple-100", "--purple-50", "--app-canvas", "--paper", "--surface-soft", "--table-heading"];
  for (const name of names) root.style.removeProperty(name);
  if (primary !== null && primary !== undefined && Number.isInteger(primary) && primary >= 0 && primary < 60) {
    const hue = (primary % 20) * 18;
    const tone = Math.floor(primary / 20);
    const saturation = [68, 57, 75][tone]!;
    root.style.setProperty("--purple-950", color(hue, Math.max(35, saturation - 22), 17));
    root.style.setProperty("--purple-900", color(hue, Math.max(38, saturation - 17), 24));
    root.style.setProperty("--purple-800", primaryColors[primary]!);
    root.style.setProperty("--purple-700", color(hue, saturation, contrastSafeLightness(hue, saturation, [39, 36, 34][tone]!)));
    root.style.setProperty("--purple-100", color(hue, 42, 91));
    root.style.setProperty("--purple-50", color(hue, 38, 97));
  }
  if (background !== null && background !== undefined && Number.isInteger(background) && background >= 0 && background < 60) {
    const hue = (background % 20) * 18;
    const tone = Math.floor(background / 20);
    const saturation = [32, 36, 40][tone]!;
    root.style.setProperty("--app-canvas", backgroundColors[background]!);
    root.style.setProperty("--paper", color(hue, saturation, Math.min(98, [98, 96, 94][tone]!)));
    root.style.setProperty("--surface-soft", color(hue, saturation, [98, 97, 95][tone]!));
    root.style.setProperty("--table-heading", color(hue, saturation, [97, 95, 93][tone]!));
  }
}
